import React from 'react';

import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';
import classNames from 'classnames';
import { ADGMImage } from 'aurora-components';

function LinearListing(props) {
  const { classes, title, defaultIcon, data } = props;
  if (!data?.length) return null;
  return (
    <>
      <Box className={classNames([classes.section, classes.sectionColumn])}>
        <Box>
          <Typography component='h2'>{title}</Typography>
        </Box>
        {data?.map(({ icon, value }) => {
          return (
            <Box className={classes.innerLines}>
              <ADGMImage name={icon || defaultIcon} />
              {value && <Typography component='p'>{value}</Typography>}
            </Box>
          );
        })}
      </Box>
    </>
  );
}

LinearListing.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  defaultIcon: PropTypes.string,
};

LinearListing.defaultProps = {
  defaultIcon: 'coins_gold.svg',
};

export default LinearListing;
